<div  class="address-map-wrapper map-common-wrap">
    
    <mat-form-field #formFieldContainer floatLabel="always"  appearance="none" class="map-label">
        <mat-label
            #labelContainer  (click)="toggleTooltip(tooltip)"
            class="{{componentDefinition?.mandatory ? 'mandatory' : ''}}">
            {{componentDefinition?.label}}
        </mat-label>
        <div class="labelToolTipContainer"
                #tooltip="matTooltip"
                matTooltip="{{componentDefinition.label}}"
                [matTooltipDisabled]="showToolTip(tooltip,formFieldContainer,labelContainer)">
        </div>
        <input matInput [hidden]="true"
                [id]="componentDefinition?.name" [name]="componentDefinition?.name"
                />
    </mat-form-field>


    <div #info id="info" class = "map-popover"
        [style.left]="infoPosition.left" [style.top]="infoPosition.top"
        [style.display]="isPopoverOpen? 'table': 'none'"
            [style.zIndex]="toolTipZIndex" >
            <div class="popover-inner" [style.zIndex]="toolTipZIndex">
                <div #tooltipInfo [id]="fieldName+'tooltipInfo'" [style.zIndex]="toolTipZIndex"
                    [class]="isToolTipScroll ? 'tooltip-scroll popover-content' : 'popover-content'">
                </div>
            </div>
    </div>
    <div #info1 id="info1" class = "map-popover"
            [style.left]="infoRadioPosition?.left" [style.top]="infoRadioPosition?.top"
            [style.display]="isPopupRadioOpen? 'table': 'none'"
            [style.zIndex]="toolTipZIndex" >
            <div class="popover-inner" [style.zIndex]="toolTipZIndex">
                <div #radioPopupInfo [id]="keyName+'radioPopupInfo'" [style.zIndex]="toolTipZIndex"
                [class]="isRadioPopupScroll ? 'tooltip-scroll popover-content' : 'popover-content'">
                    <div *ngFor="let post of postList" [innerHtml]="post | sanitizeHtml"></div>
                    <button type="button" class="btn" style="color:black;" [hidden]="!allowSelectAsset" (click)="closeClusterPopup(false)" >Close</button>
                    <button type="button" class="btn" style="color:black;" [hidden]="allowSelectAsset" (click)="closeClusterPopup(true)" >OK</button>
                </div>
            </div>
    </div>
    <div [id]="fieldName+'address-map'" [style.height.px]="mapHeight">
        <div [id]="fieldName+'gblMap'" class='gblMap' style="height:100%;  width:100%;position: relative;">
            <!-- div info will put here after render map -->
        </div>
    </div>
    <!-- <ft-validation-message ng-model="doc[fieldName]"/> -->
    <span #loadingMessageItem
        style="position: absolute; margin-left: 10px;"
        [style.marginTop.px]="loadingMessageItemMarginTop"
        [hidden]="!isLoadingAsset">
        Loading {{assetLoaded}} of {{assetTotal}} items...
    </span>
    <span #loadingMessageIcon
         style="position: absolute; margin-left: 10px;"
         [style.marginTop.px]="loadingMessageIconMarginTop"
         [hidden]="!isLoadingIconAsset">
        Loading asset icon...
    </span>
</div>
